import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { useJustification } from 'providers/Justification';

import { actions } from '../../../modules';

type RemoveParams = { packageId: string; projectId: string };

interface HookProps {
  onSuccess?: (params: RemoveParams) => void;
}

interface UsePackageProjectRemoval {
  removeProjectFromPackage(params: RemoveParams): void;
  loading: boolean;
}

export function usePackageProjectRemoval({ onSuccess }: HookProps = {}): UsePackageProjectRemoval {
  const { t } = useLang();

  const removePackage = actions.invoice.removeProjectFromPackage.use({
    onSuccess: (_, params) => onSuccess?.(params),
  });

  const { openJustificationModal } = useJustification();

  return useMemo(
    () => ({
      loading: removePackage.loading,

      removeProjectFromPackage: (params) => {
        openJustificationModal({
          text: t('justify-project-removal-from-pkg'),

          onConfirm: (justification) =>
            removePackage.execute({
              justification,
              ...params,
            }),
        });
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [openJustificationModal, removePackage.execute, t, removePackage.loading],
  );
}
